export enum WheelieBinStatus {
    Stolen = 0,
    New = 1,
    TakenIn = 2,
    Active = 3,
    Defect = 4,
    Blocked = 5,
    Destroyed = 6,
}
